import { gql } from "@apollo/client";

export const TARIFF_DETAILS = gql`
  query TariffDetails(
    $customer: String!
    $group: String!
    $meterType: String!
    $address: String!
    $meteringPointId: String
    $year: Int!
    $month: Int!
  ) {
    tariffDetails(
      customer: $customer
      group: $group
      meterType: $meterType
      address: $address
      meteringPointId: $meteringPointId
      year: $year
      month: $month
    ) {
      customer
      group
      address
      year
      month
      taxes {
        meteringPointId
        consumption
        elagift
        minimumsafgift
        godtgorelsessats
        tsoSystemAbonnement
        transmissionsNettarif
        systemtarif
        abonnement
        rabatAbonnement
        nettariff
        rabatNettariff
        rabatNettariffHourly {
          tariff
          ts
        }
        nettariffHourly {
          tariff
          ts
        }
        netFast
      }
      metersInfo {
        customer
        meter
        consumerCVR
        meterNumber
        streetName
        buildingNumber
        postcode
        cityName
        email
        address
        gridOperatorName
      }
    }
  }
`;
